<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <v-container grid-list-md px-0 py-0>
      <v-card>
        <v-card-title class="pb-0">
          <span class="headline">{{formTitle}}</span>
        </v-card-title>

        <v-card-text class="pt-0">
          <v-container grid-list-md px-0 py-0>
            <v-form v-model="valid" xs12>
              <v-layout row wrap>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.name" label="Nome"></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field v-model="editedItem.email" label="email ou usuário"></v-text-field>
                </v-flex>
                 <v-flex xs12 sm4 md4>
                  <v-text-field type="password" v-model="editedItem.password" label="Senha"></v-text-field>
                </v-flex>
                
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm4 md4>
                  <v-select v-model="editedItem.level" :items="levels" label="Nivel" dense></v-select>
                </v-flex>
              </v-layout>
            </v-form>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray" flat @click.native="close">Fechar</v-btn>
              <v-btn color="primary" @click.native="save" :disabled="!valid">SALVAR</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </v-dialog>
</template>
<script>
import moment from "moment";
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
  props: ["active", "finish", "item", "category"],
  directives: {
    mask,
  },

  data() {
    let edited = {};

    if (this.item.id) {
      edited = this.item;
    }

    return {
      cat: this.category,
      dialog: this.active,
      editedItem: edited,
      valid: false,
      levels: [
        {"value": "1", "text": "Admin"},
        {"value": "2", "text": "Atendente"},
       // {"value": "3", "text": "Cozinha"},
      ]
    };
  },
  computed: {
    formTitle() {
      return this.editedItem.id ? "Usuário" : "Usuário";
    },
  },
  watch: {
    dialog(val) {
      if (!val && this.finish) {
        this.finish();
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      console.log(this.item);
    },
    close() {
      this.dialog = false;
    },
    save() {

      if (this.editedItem.id) {
        this.update();
      } else {
        this.add();
      }
    },
    add() {
      this.$http
        .post(`/users/store`, this.editedItem)
        .then((response) => response.data)
        .then((json) => {
          this.$notify({
            title: `Usuário ${this.editedItem.name} adicionado com sucesso!`,
            type: "success",
          });
          this.close();
        })
        .catch((err) => {
          this.$notify({
            duration: 15000,
            title: `Erro ao Adicionar Usuário!`,
            text: err.response,
            type: "error",
          });
        });
    },
    update() {
      this.$http
        .put(`/users/${this.editedItem.id}`, this.editedItem)
        .then((response) => {
          this.$notify({
            title: `Usuário ${this.editedItem.name} salvo com sucesso!`,
            type: "success",
          });
          this.close();
        });
    },
  },
};
</script>
